import { SHOPIFY_APP_ORDERS_URL } from 'constants'
import { receiveOrdersData } from '../actions/shopifyAnalyticsAC'
import { initDashboardShopifyBar } from './shopifyBar'

export function initShopifyDashboard (appId) {
  return function * (dispatch, getState) {
    console.log('initShopifyDashboard', appId)
    if (appId) {
      initDashboardShopifyBar(appId)
    } else {
      console.warn('initShopifyDashboard: user has no apps')
    }
  }
}

export function fetchAnalytics (date) {
  return function * (dispatch, getState) {
    const shopName = getState().user.shop
    const dateStart = date.start.toISOString()
    const dateEnd = date.end.toISOString()
    const body = {
      start: dateStart,
      end: dateEnd,
      shopName
    }
    console.log('body', body)
    const options = {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }
    const result = yield fetch(SHOPIFY_APP_ORDERS_URL, options)
    const data = yield result.json()
    dispatch(receiveOrdersData(data))
  }
}

export function getDefaultAnalyticsDateRange () {
  const endDate = new Date(Date.now())
  const startDate = new Date(endDate.getTime())
  startDate.setMonth(endDate.getMonth() - 1)
  return {start: startDate, end: endDate}
}



// WEBPACK FOOTER //
// ./src/controllers/shopifyDashboard.js